import CardActions, { CardActionsProps } from "@mui/material/CardActions";

export type { CardActionsProps };

export default CardActions;
